import { useMemo, useState } from 'react';
import { ExamType } from '../../api/exam';
import Search, { MIN_SEARCH_LENGTH } from '../shared/search';
import Exam from './exam';

export type ExamListPropsType = {
  exams: ExamType[];
};

function ExamList({ exams }: ExamListPropsType) {
  const [search, setSearch] = useState('');

  const filteredExams = useMemo(() => {
    const trimmed = search.trim();
    if (trimmed.length < MIN_SEARCH_LENGTH) return exams;
    const needle = trimmed.toLowerCase();
    return exams.filter(exam => exam.name?.toLowerCase().includes(needle));
  }, [search, exams]);

  return (
    <>
      <Search search={search} setSearch={setSearch} />
      <div className='flex flex-col'>
        {filteredExams.map(exam => (
          <Exam key={exam.id} exam={exam} />
        ))}
      </div>
    </>
  );
}

export default ExamList;
